import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import UserQuestionnaire from './user-questionnarie';
import { setEDDStatus } from '../../Redux/store/userSlice';
const EDDCustomer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [eddResponse, setEddResponse] = useState(null);
  const [eddId, setEddId] = useState(null);
  const username = useSelector((state) => state.user.username);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    eddResponse?.pending?.[0]?.questions || [],
  );

  // const completedQuestions = mapQuestions(
  //   (eddResponse?.completed || []).flatMap((item) => item?.questions || []),
  // );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/customer/edd/responses`);
      if (response.status == 200) {
        setEddResponse(response.data);
        if (response.data?.pending?.[0]?.questions?.length > 0) {
          setEddId(response.data.pending[0].id);
          dispatch(setEDDStatus(true));
        } else {
          dispatch(setEDDStatus(false));
        }
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };

  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/customer/review-submit/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  useEffect(() => {
    getEddResponses();
  }, []);

  return (
    <div className="p-4 flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[100vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="bg-white border rounded-md p-4 mt-4">
            {pendingQuestions.length > 0 && eddId && (
              <div className="w-full p-4">
                <UserQuestionnaire
                  apidata={pendingQuestions}
                  customerName={username}
                  isPending={true}
                  eddId={eddId}
                  afterSubmit={getEddResponses}
                  heading={'Customer Enhanced Due Diligence Questionnaire'}
                />
              </div>
            )}
            {completedGroups.length > 0 && (
              <div className="w-full p-4">
                <UserQuestionnaire
                  apidata={completedGroups}
                  customerName={username}
                  isPending={false}
                  eddId={eddId}
                  afterSubmit={getEddResponses}
                  heading={'Customer Enhanced Due Diligence Questionnaire'}
                />
              </div>
            )}{' '}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EDDCustomer;
